import { createModal, openModal, closeModal, generateUniqueId, addCloseEventListener } from './custom-modal';

const disclosureModal = () => {
    const root = document.querySelector('#root');
    const carousel = document.querySelector('.homepage-video-carousel');
    
    if (!carousel || !root) return;
    
    addCloseEventListener();

    let modalsContainer = document.querySelector('.modals-container');
    
    if (!modalsContainer) {
        modalsContainer = document.createElement('div');
        modalsContainer.className = 'modals-container';
        root.appendChild(modalsContainer);
    }

    $(document).on('click', '.video-hero-more-info-top a', function(e) {
        e.preventDefault();
        
        const button = $(this);
        const slide = button.closest('.hero')[0];
        const disclosure = slide.querySelector('.hero__description');
        
        if (!disclosure) return;

        let modalId = button.attr('data-modal-id');
        
        if (!modalId) {
            modalId = generateUniqueId();
            button.attr('data-modal-id', modalId);

            const modal = createModal(disclosure, modalId);
            modalsContainer.appendChild(modal);

            modal.querySelector('.modal__close').addEventListener('click', () => closeModal(modalId));
            modal.querySelector('.modal__overlay').addEventListener('click', () => closeModal(modalId));
        }

        openModal(modalId);
    });
}

window.addEventListener("DOMContentLoaded", disclosureModal);